export default function parseQueryString(query?: string): Record<string, string | undefined> {
  query = query || window.location.search
  let queryObj: Record<string, string | undefined> = {}
  query.replace(
    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
    function (a, b, c, d) {
      queryObj[b] = d
      return a
    }
  )
  return queryObj
}
